import * as React from "react"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Form from "react-bootstrap/Form"

import { Feedback } from "../../../../../components/Validator"

import DecimalDigits, {
  defaultDigits,
  decimalDigitsControlId
} from "./DecimalDigits"
import { UiTypes } from "./UIModel"

const defaultRangeId = "defaultDecimalNumberRangeProperty"
const minRangeId = "minDecimalNumberRangeProperty"
const maxRangeId = "maxDecimalNumberRangeProperty"
const measureTypeId = "measureTypeProperty"

interface ConfigureMeasureNumberProps {
  default?: string
  min?: string
  max?: string
  decimalDigits?: number
  valid: Feedback
  disabled: boolean
  measureType: string
  setDisabled: (value: boolean) => void
  onUpdate: () => void
  setDefault: (id: string, e: any, valueType?: "Number" | "Decimal" | "Measure") => void
  setMin: (id: string, e: any, isDecimal?: boolean) => void
  setMax: (id: string, e: any, isDecimal?: boolean) => void
  setDecimalDigits: (controlId: string, digits: number) => void
  setMeasureType: (controlId: string, type: any) => void
}

const ConfigureMeasureNumber = (props: ConfigureMeasureNumberProps) => {
  const disabledDefault =
    props.disabled || (!props.valid.valid && props.valid.id !== defaultRangeId)
  const disabledMin =
    props.disabled || (!props.valid.valid && props.valid.id !== minRangeId)
  const disabledMax =
    props.disabled || (!props.valid.valid && props.valid.id !== maxRangeId)
  const disabledDecimalDigits =
    props.disabled ||
    (!props.valid.valid && props.valid.id !== decimalDigitsControlId)

  const inValidDefault = props.valid.id === defaultRangeId
  const inValidMin = props.valid.id === minRangeId
  const inValidMax = props.valid.id === maxRangeId

  const setDefault = (e: any) => props.setDefault(defaultRangeId, e, "Decimal")
  const setMin = (e: any) => props.setMin(minRangeId, e, true)
  const setMax = (e: any) => props.setMax(maxRangeId, e, true)
  const setMeasureType = (e: any) => props.setMeasureType(measureTypeId, e)

  const getMeasureTypeOptions = (x: string[]) =>
      x.map((type, i) => {
          return (
            <option key={`${i}_option_${type}`} value={type}>
              {type}
            </option>
          )
      })

  return (
    <Form>
      <Form.Group as={Row} controlId={defaultRangeId}>
        <Form.Label column={true} md="3">
          Default
        </Form.Label>
        <Col md="9">
          <Form.Control
            type="number"
            step={1}
            min={props.min || -2147483648}
            max={props.max || 2147483647}
            value={props.default || ""}
            onChange={setDefault}
            onBlur={props.onUpdate}
            disabled={disabledDefault}
            isInvalid={inValidDefault}
          />
          <Form.Control.Feedback type="invalid">
            {props.valid.message}
          </Form.Control.Feedback>
          <Form.Text>
            An optional default value in meters. Leave empty if none should be set.
          </Form.Text>
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId={minRangeId}>
        <Form.Label column={true} md="3">
          Minimum
        </Form.Label>
        <Col md="9">
          <Form.Control
            type="number"
            step={0.01}
            min={-2147483648}
            max={props.max || 2147483647}
            value={props.min || ""}
            onChange={setMin}
            onBlur={props.onUpdate}
            disabled={disabledMin}
            isInvalid={inValidMin}
          />
          <Form.Control.Feedback type="invalid">
            {props.valid.message}
          </Form.Control.Feedback>
          <Form.Text>
            An optional minimum value in meters. Leave empty if none should be set.
          </Form.Text>
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId={maxRangeId}>
        <Form.Label column={true} md="3">
          Maximum
        </Form.Label>
        <Col md="9">
          <Form.Control
            type="number"
            step={0.01}
            min={props.min || -2147483648}
            max={2147483647}
            value={props.max || ""}
            onChange={setMax}
            onBlur={props.onUpdate}
            disabled={disabledMax}
            isInvalid={inValidMax}
          />
          <Form.Control.Feedback type="invalid">
            {props.valid.message}
          </Form.Control.Feedback>
          <Form.Text>
            An optional maximum value in meters. Leave empty if none should be set.
          </Form.Text>
        </Col>
      </Form.Group>

      <DecimalDigits
        value={
          typeof props.decimalDigits === "undefined"
            ? defaultDigits
            : props.decimalDigits
        }
        onChange={props.setDecimalDigits}
        onBlur={props.onUpdate}
        disabled={disabledDecimalDigits}
      />

      <Form.Group as={Row} controlId={measureTypeId}>
        <Form.Label column={true} md="3">
          MeasureType
        </Form.Label>
        <Col md="9">
          <Form.Control
              as='select'
              value={props.measureType}
              onChange={setMeasureType}
              onBlur={props.onUpdate}
            >
              <option value='' disabled={true}>-- please select --</option>
              {getMeasureTypeOptions(UiTypes.MeasureTypes)}
          </Form.Control>
          <Form.Control.Feedback type="invalid">
            {props.valid.message}
          </Form.Control.Feedback>
          <Form.Text>
            The type of measurement.
          </Form.Text>
        </Col>
      </Form.Group>

    </Form>
  )
}

export default ConfigureMeasureNumber
